import useGetOrganizations from './useGetOrganizations';

export default useGetOrganizations;
export * from './useGetOrganizations';
